// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#WysiwygInput.focus {
  border-color: #87acdf;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
#WysiwygInput .disabled {
  background: hsla(236, 24%, 87%, 0.5);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
}
#WysiwygInput h1,
#WysiwygInput h2,
#WysiwygInput h3,
#WysiwygInput h4,
#WysiwygInput h5,
#WysiwygInput h6 {
  line-height: 1;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}
#WysiwygInput p {
  margin-bottom: 0.6rem;
  line-height: 1.2rem;
}
#WysiwygInput ul li p, #WysiwygInput ol li p {
  margin-bottom: 0.2rem;
}
#WysiwygInput p.is-editor-empty:first-child::before {
  color: #9ea0b9;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}
#WysiwygInput .tiptap {
  overflow: auto;
  outline: none;
}
#WysiwygInput .toolbar {
  margin-bottom: 16px;
}
#WysiwygInput .toolbar button {
  padding: 0px 6px;
  font-size: 12px;
  font-weight: bold;
  box-shadow: none;
  height: 100%;
}
#WysiwygInput .toolbar button i {
  padding: 0px 4px;
  font-size: 15px;
}

/* OLD */
/* #WysiwygInput {
    display: flex;
    flex-direction: column;

    &.focus {
        border-color: #87acdf;
        outline: 0;
        box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
    }

    .disabled {
        background: hsla(236, 24%, 87%, 0.5);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 500;
    }

    button {
        padding: .1rem .8rem;
    }

    [contenteditable][placeholder]:empty:before {
        content: attr(placeholder);
        position: absolute;
        color: #9ea0b9;
        background-color: transparent;
        display: contents;
    }

    .wysiwygEditionArea {
        overflow: auto;
        outline: none;
        cursor: text;

        h1 {
            font-size: 1.6rem;
        }

        h2 {
            font-size: 1.4rem;
        }

        h3 {
            font-size: 1.2rem;
        }
    }

} */`, "",{"version":3,"sources":["webpack://./src/components/form-inputs/wysiwyg-input/WysiwygInput.scss"],"names":[],"mappings":"AAEI;EACI,qBAAA;EACA,UAAA;EACA,iDAAA;AADR;AAII;EACI,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAFR;AAMI;;;;;;EAMI,cAAA;EACA,kBAAA;EACA,qBAAA;AAJR;AAOI;EACI,qBAAA;EACA,mBAAA;AALR;AAUY;EACI,qBAAA;AARhB;AAaI;EACI,cAAA;EACA,+BAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;AAXR;AAcI;EACI,cAAA;EACA,aAAA;AAZR;AAeI;EACI,mBAAA;AAbR;AAeQ;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAbZ;AAeY;EACI,gBAAA;EACA,eAAA;AAbhB;;AAoBA,QAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA","sourcesContent":["#WysiwygInput {\n\n    &.focus {\n        border-color: #87acdf;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);\n    }\n\n    .disabled {\n        background: hsla(236, 24%, 87%, 0.5);\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 500;\n    }\n\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        line-height: 1;\n        margin-top: 1.5rem;\n        margin-bottom: .5rem;\n    }\n\n    p {\n        margin-bottom: .6rem;\n        line-height: 1.2rem;\n    }\n\n    ul,ol {\n        li {\n            p {\n                margin-bottom: .2rem;\n            }\n        }\n    }\n\n    p.is-editor-empty:first-child::before {\n        color: #9ea0b9;\n        content: attr(data-placeholder);\n        float: left;\n        height: 0;\n        pointer-events: none;\n    }\n\n    .tiptap {\n        overflow: auto;\n        outline: none;\n    }\n\n    .toolbar {\n        margin-bottom: 16px;\n\n        button {\n            padding: 0px 6px;\n            font-size: 12px;\n            font-weight: bold;\n            box-shadow: none;\n            height: 100%;\n\n            i {\n                padding: 0px 4px;\n                font-size: 15px;\n            }\n        }\n    }\n\n}\n\n/* OLD */\n/* #WysiwygInput {\n    display: flex;\n    flex-direction: column;\n\n    &.focus {\n        border-color: #87acdf;\n        outline: 0;\n        box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);\n    }\n\n    .disabled {\n        background: hsla(236, 24%, 87%, 0.5);\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 500;\n    }\n\n    button {\n        padding: .1rem .8rem;\n    }\n\n    [contenteditable][placeholder]:empty:before {\n        content: attr(placeholder);\n        position: absolute;\n        color: #9ea0b9;\n        background-color: transparent;\n        display: contents;\n    }\n\n    .wysiwygEditionArea {\n        overflow: auto;\n        outline: none;\n        cursor: text;\n\n        h1 {\n            font-size: 1.6rem;\n        }\n\n        h2 {\n            font-size: 1.4rem;\n        }\n\n        h3 {\n            font-size: 1.2rem;\n        }\n    }\n\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
